import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tooltip } from 'antd';
import { useI18n } from '@newtontechnologies/applib-frontend';
import Status, { STATUS_VALUE } from '../../Status';
import { useQueue } from '../../../queue-context';
import './style.less';
const SplitPart = ({ task, split }) => {
    const { intl } = useI18n();
    const queue = useQueue();
    const partName = `${task.projectName}_${split.filePath}`;
    const partItem = split.beeyProjectId === null ? (_jsx("div", { className: "split-part__name", children: partName })) : (_jsx("div", { className: "split-part__name", children: _jsx("a", { className: "part-item", href: `/edit/${split.beeyProjectId}`, target: "_blank", rel: "noreferrer", children: partName }) }));
    let status = STATUS_VALUE.WAITING;
    if (split.beeyProjectError) {
        status = STATUS_VALUE.ERROR;
    }
    else if (queue !== undefined && queue.workingOnSplitId.includes(split.id)) {
        status = STATUS_VALUE.RUNNING;
    }
    else if (split.fileTranscribed) {
        status = STATUS_VALUE.DONE;
    }
    else if ((queue === null || queue === void 0 ? void 0 : queue.beeyPositions.find(({ splitId }) => splitId === split.id)) !== undefined) {
        status = STATUS_VALUE.WAITING;
    }
    const errorMessage = () => {
        if (split.errorMessage !== null && split.errorMessage.includes('Not enough credit')) {
            return intl.formatMessage({ id: 'notEnoughCredit' });
        }
        return split.errorMessage;
    };
    return (_jsx("div", { children: _jsxs(Tooltip, { title: errorMessage(), className: "split-part", children: [_jsx(Status, { status: status, size: "small" }), _jsx("div", { className: "split-part__body", children: partItem })] }) }));
};
export default SplitPart;
